import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TRANSLOCO_LOADER, TRANSLOCO_TRANSPILER, TRANSLOCO_CONFIG, translocoConfig, TranslocoService } from '@ngneat/transloco';
import { HttpLoaderTranslateService, CustomTranspiler, CustomTranslationService } from '../services/http-loader-translate.service';



@NgModule({
  declarations: [],
  providers:[
    { provide: TranslocoService, useClass: CustomTranslationService},
    { provide: TRANSLOCO_LOADER, useClass: HttpLoaderTranslateService },
    {
      provide: TRANSLOCO_TRANSPILER,
      useClass: CustomTranspiler
    },
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        reRenderOnLangChange: true,
        fallbackLang: 'en',
        availableLangs: ['en', 'nl', 'fr'],
        defaultLang: 'en',
        missingHandler:{
          logMissingKey : false,
          useFallbackTranslation: true
        }
      })
    },
  ],
  imports: [
    CommonModule,
    TranslocoModule
  ],
  exports:[
    TranslocoModule
  ]
})
export class CommonTranslateModule { }
